import { render, staticRenderFns } from "./HistorialEmergenciaLink.vue?vue&type=template&id=be517bdc&scoped=true"
import script from "./HistorialEmergenciaLink.vue?vue&type=script&lang=js"
export * from "./HistorialEmergenciaLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be517bdc",
  null
  
)

export default component.exports